<template>
  <div class="transaction-container">
    <div class="header">{{ $route.params.company_name }}</div>
    <nav class="add-navigation">
      <div
        @click="$router.push({ name: 'system-admin-company-list' })"
        class="back-link"
      >
        <svg
          class="icon"
          width="30px"
          height="30px"
          viewBox="0 0 30 30"
          version="1.1"
        >
          <path
            d="M9.82106781,14.25 L23,14.25 L23,16.25 L9.84421387,16.25 L11.6568542,18.0626404 L10.2426407,19.4768539 L7.41842728,16.6526405 L7.41421356,16.6568542 L7.00735931,16.25 L7,16.25 L7,16.2426407 L6,15.2426407 L6.00421371,15.238427 L6,15.2342133 L7.41421356,13.8199997 L7.41842728,13.8242134 L10.2426407,11 L11.6568542,12.4142136 L9.82106781,14.25 Z"
            id="path-1"
          />
        </svg>
        <p>Back to Companies</p>
      </div>
    </nav>
    <h4>Balance as of YYYY-MM-DD is $ XXXX</h4>
    <div
      class="table_div"
      style="width: 100%; overflow-x: auto; overflow-y: hidden"
    >
      <table
        class="Invoice_table"
        border="1"
        align="center"
        cellpadding="4"
        cellspacing="0"
      >
        <thead>
          <tr class="bg-blue">
            <th style="border-bottom: none">Date</th>
            <th style="border-bottom: none">Payment</th>
            <th style="border-bottom: none">SMS Usage</th>
            <th colspan="2" rowspan="2">DID</th>
            <th style="border-bottom: none">Balance</th>
          </tr>
        </thead>
        <tbody>
          <tr class="line custom-line bg-blue">
            <td style="border-top: none"></td>
            <td style="border-top: none"></td>
            <td style="border-top: none"></td>
            <td>MRC</td>
            <td>NRC</td>
            <td style="border-top: none"></td>
          </tr>
          <tr class="line" v-for="(payment, k) in payments" :key="k">
            <td>{{ payment.date }}</td>
            <td>{{ payment.payment }}</td>
            <td></td>
            <td></td>
            <td></td>
            <td>${{ payment.amount }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="per-page">
      <span class="filter_by custom-row">Show Per Page:</span>
      <div class="primary-input-container choose-type perPage">
        <primary-select
          type="text"
          @input="changePerPage"
          v-model="per_page" :is-cross="false"
          class="choose-type perPage"
          placeholder="Select"
        >
          <option :value="item" v-for="(item, key) in pages" :key="key">
            {{ item }}
          </option>
        </primary-select>
      </div>
    </div>
    <div class="buttons-wrapper">
      <pagination-component
        @change-page="changePage($event)"
        :page="Page"
        :total="TotalPages"
        :perPage="per_page"
        :qnt="payments.length"
      />
    </div>
  </div>
</template>

<script>
import { format } from "date-fns";

export default {
  components: {
    DownloadAttachmentDropDown: () =>
      import("@/components/DropDowns/Billing/DownloadAttachmentDropDown.vue"),
    SearchInput: () => import("@/components/Inputs/SearchInput.vue"),
    SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
    PaginationComponent: () => import("@/components/Pagination.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
  },
  data: () => ({
    showDropDown: false,
    payments: [],
    per_page: 10,
    pages: [10, 50, 100],
    TotalPages: null,
    Searched: "",
    Page: 0,
  }),
  created() {
    this.GetList(this.Searched, this.Page);
  },
  methods: {
    changePerPage() {
      this.Page = 0;
      this.GetList(this.Searched, this.Page);
    },
    changePage(page) {
      this.Page = page;
      this.GetList(this.Searched, this.Page);
    },
    GetList(search, page) {
      this.$store
        .dispatch("GetPaymentList", {
          search: search,
          page: page,
          per_page: this.per_page,
        })
        .then((res) => {
          this.payments = res.items.map(this.transformPayments);
          this.TotalPages = res.total / res.per_page;
        });
    },
    transformPayments(i, k) {
      return {
        invoiceId: i.invoice_uuid,
        invoiceNumber: i.invoice_number,
        createdBy: i.created_by,
        payment: i.method,
        companyName: i.company_name,
        date: format(i.created_on, "YYYY:MM:DD HH:mm:ss"),
        amount: i.amount,
      };
    },
    outside() {
      this.showDropDown = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.transaction-container {
  padding: 0 20px;

  h4 {
    font-size: 16px;
  }
  .custom-line {
    box-shadow: none !important;
  }
  .per-page {
    display: flex;
    align-items: center;
    margin-top: 20px;
  }
  .perPage {
    width: 120px;
    margin-right: 15px;
  }
  .header {
    //padding: 15px 0;
    font-size: 16px;
    color: #666;
  }
  .add-navigation {
    width: 100% !important;
    align-items: center;
    height: 40px;
    float: right;
    margin-bottom: 20px;
    .back-link {
      cursor: pointer;
      display: flex;
      align-items: center;
      fill: #51a3f3;
      color: #51a3f3;
      font-family: "Helvetica Neue";
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
      p {
        margin: 0;
      }
    }
  }
  .bg-blue > td,
  .bg-blue > th {
    padding-left: 15px;
    border: 1px solid #dee2e6;
    background: #51a3f3;
    color: #fff;
  }
}
table.Invoice_table {
  width: 100%;
  margin-top: 20px;

  th,
  td {
    text-align: center;
  }
}
/*table thead tr {*/
/*   height: 37px;*/
/*    background: #F8F9FE;*/
/*    text-align: left;*/
/*}*/

table,
tr {
  width: 100%;
  height: 40px;
  background-color: #ffffff;
}
table {
  border-collapse: collapse;
}
.Invoice_table_popup {
  text-align: right;
  position: relative;
  float: right;
  .popup_cta {
    cursor: pointer;
    color: #55616e;
  }
}
.Invoice_table_header th {
  height: 16px;
  color: #212b36;
  font-weight: normal;
  font-family: "Helvetica Neue";
  font-size: 16px;
  font-weight: 600;
  line-height: 16px;
  padding: 0.75rem;
  text-align: center;
}
.popup_content {
  display: none;
}
.popup_cta {
  cursor: pointer;
}
.Invoice_price {
  font-family: "Helvetica Neue";
  padding: 12px 0 12px 0;
  color: #000000;
  font-weight: bold;
  line-height: 20px;
}
.Invoice_table_header th.Invoice_header_total {
  padding-left: 40px;
}
.Invoice_table_popup.active .popup_content {
  display: block;
  position: absolute;
  right: 0;
  width: 240px;
  border-radius: 4px;
  background-color: #ffffff;
  box-shadow: 0 10px 40px 0 rgba(0, 0, 0, 0.1);
  padding-left: 0;
  list-style-type: none;
  text-align: left;
}
.Invoice_table_popup.active .popup_content a {
  color: #55616e;
  font-size: 16px;
  line-height: 20px;
  text-decoration: none;
  font-family: "Helvetica Neue";
  padding: 10px 15px;
  display: inline-block;
}
.popup_image {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  vertical-align: middle;
  margin-right: 8px;
}
.table_div::-webkit-scrollbar {
  // width: 5px;
  width: 8px;
  height: 8px;
  background-color: #f5f5f5;
}

.table_div::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-image: -webkit-gradient(
    linear,
    left bottom,
    left top,
    color-stop(0.44, #51a3f3),
    color-stop(0.72, #51a3f3),
    color-stop(0.86, #51a3f3)
  );
}

@media screen and (max-width: 1300px) {
  table.Invoice_table {
    width: 1000px;
  }
}
</style>

